import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const batukPartnerApi = createAsyncThunk("batukPartner", async () => {
  const response = await axiosInstance.get("/partner/commission");
  return response.data;
});

const batukPartnerSlice = createSlice({
  name: "batukPartner",
  initialState: {
    batukPartner: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(batukPartnerApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(batukPartnerApi.fulfilled, (state, action) => {
        state.batukPartner = action.payload;
        state.loading = false;
      })
      .addCase(batukPartnerApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default batukPartnerSlice.reducer;
